<template>
    <h1>Checkout Page</h1>

    <!-- <form action="/charge" method="post" :id="formId"> -->
    <Form
        @submit="onSubmit()"
        id="payment-form"
        :validation-schema="schemaValidation"
        v-slot="{ errors }"
    >
        <div v-if="status == 'complete'" class="uk-child-width-1-1" uk-grid>
            <div>
                <div class="uk-card uk-card-primary uk-card-body uk-text-center">
                    <h3>Thank You</h3>
                    <div class="uk-grid-small" uk-grid>

                        <div class="uk-width-1-1">
                            <p class="uk-text-large">Your payment has gone through</p>
                        </div>
                        <div class="uk-width-1-1">
                            <p>
                                <button @click="startAgain()" class="uk-button uk-button-large uk-button-primary uk-input-rounded">
                                    <span>Start Again</span>
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="uk-child-width-1-1" uk-grid>
            <div>
                <div class="uk-card uk-card-default uk-card-body">
                    <h3>Your details</h3>
                    <div class="uk-grid-small" uk-grid>
                        <div
                            v-for="field in form_schema.customer_fields" :key="field.key"
                            class="uk-width-1-1" >
                            <label class="uk-form-label" for="form-stacked-text">{{ field.label }}</label>
                            <Field
                                class="uk-input uk-input-rounded"
                                :placeholder="field.label"
                                :name="field.name"
                                as="input"
                                :class="{ 'uk-form-danger': errors.[field.name] }"
                                :value="customer.[field.name]"
                                @input="updateCustomer"
                            />
                            <div class="invalid-feedback">{{ errors.[field.name] }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="uk-card uk-card-default uk-card-body">
                    <h3>Payment</h3>
                    <div class="uk-grid-small" uk-grid>
                        <div class="uk-width-1-1">
                            <label class="uk-form-label" for="card-element"> Credit or debit card </label>
                            <div id="card-element"> <!-- A Stripe Element will be inserted here. --> </div>
                        </div>

                        <div id="card-errors" v-if="stripe_data.error.message " class="uk-width-1-1">
                            <div class="uk-alert-danger" role="alert" uk-alert>
                                <a class="uk-alert-close" uk-close></a>
                                <p>{{ stripe_data.error.message }}</p>
                            </div>
                        </div>

                        <div class="uk-width-1-1">
                            <button class="uk-button uk-button-large uk-button-primary uk-input-rounded">
                                <div v-if="sending" uk-spinner></div>
                                <span v-else>Submit Payment</span>
                            </button>
                        </div>
                    </div>
                    <p>Payment is taken using Stripe, you will see 'LANDON ROAD PHOTOS' as your payment descriptor.</p>
                </div>
            </div>

        </div>
    </Form>

    <teleport to="#app-sidebar">
        <AppCart />
    </teleport>
</template>

<script>
import AppCart from "@/components/app/Cart"
import { mapState, mapActions, mapGetters } from 'vuex'

import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'

export default {
    components: {
        AppCart,
        Form,
        Field,
    },

    data () {
        const schemaValidation = Yup.object().shape({
            full_name:    Yup.string().required('Full Name is required'),
            address_1:    Yup.string().required('No. / Street is required'),
            address_2:    Yup.string().required('Town is required'),
            city:         Yup.string().required('City is required'),
            postcode:     Yup.string().required('Postcode is required'),
            email:        Yup.string().email('Email format is invalid').required('Email is required'),
            phone_number: Yup.string().required('Phone Number is required'),
        })

        return {
            schemaValidation,
            sending: false,
            status: '',
            stripe_data: {
                stripe: {},
                elements: {},
                card: {},
                client_secret: '',
                payment_intent_id: '',
                error: {},
            },
            form_schema: {
                customer_fields: [
                    { label: 'Full Name', name: 'full_name', as: 'input', },
                    { label: 'No. / Street', name: 'address_1', as: 'input', },
                    { label: 'Town', name: 'address_2', as: 'input', },
                    { label: 'City', name: 'city', as: 'input', },
                    { label: 'Postcode', name: 'postcode', as: 'input', },
                    { label: 'Email', name: 'email', as: 'input', },
                    { label: 'Phone Number', name: 'phone_number', as: 'input', },
                ],
            },
        }
    },

    mounted() {
        let _this = this

        // Create a Stripe client.
        if ( process.env.NODE_ENV == 'production' ) {
            this.stripe_data.stripe = Stripe('pk_live_51HqTZqGChDDavhhTKwVOXZ7qSkENMRLbHRFsxPeZ8fCDoP9MyijQ6WTjqOUtpoJkWlmaR1eywtjaz9GVJY6YclE500Lcp320Fp');
        } else {
            this.stripe_data.stripe = Stripe(process.env.MIX_STRIPE_KEY_TEST);
        }

        // Create an instance of Elements.
        this.stripe_data.elements = this.stripe_data.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        this.stripe_data.card = this.stripe_data.elements.create('card', {style: style});

        // Add an instance of the card Element into the `card-element` <div>.
        this.stripe_data.card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        this.stripe_data.card.on('change', function(event) {
            if (event.error) {
                _this.stripe_data.error = event.error
            } else {
                _this.stripe_data.error = {}
            }
        });

    },

    computed: {
        ...mapState({
            cartProducts: state => state.cart_products,
        }),
        ...mapGetters({
            customer:          'customer',
            eventData:         'eventData',
            cartSubTotal:      'cartSubTotal',
            cartShippingTotal: 'cartShippingTotal',
            cartTotal:         'cartTotal',
            cartTotal:         'cartTotal',
            freeDelivery:    'freeDelivery',
        }),
    },

    methods: {
        ...mapActions ({
            updateCustomer: 'updateCustomer',
            startAgain:     'startAgain',
        }),

        stripeTokenHandler(token) {
            this.stripe_data.token = token
        },

        onSubmit() {
            let _this = this

            // Don't trigger if already sending.
            if (_this.sending == true) return

            _this.sending = true

            // Handle form submission. first we create a token
            _this.createPaymentIntent()

            // Check for errors
            if (_this.stripe_data.error.message) return

        },

        createPaymentIntent () {
            let _this = this

            if (_this.stripe_data.client_secret != '') {
                // If we already have a client secret recorded in data, use that. This stops duplicates being created on stripe.
                _this.confirmCardPayment(_this.stripe_data.client_secret)
            } else {
                _this.axios.post('/api/v1/checkout', {
                    cart_total: _this.cartTotal,
                    customer: _this.customer,
                })
                .then((response) => {
                    if (response.data.client_secret) {
                        _this.stripe_data.client_secret = response.data.client_secret
                        _this.stripe_data.payment_intent_id = response.data.payment_intent_id
                        _this.confirmCardPayment(response.data.client_secret)
                    }
                })
            }
        },

        confirmCardPayment (clientSecret) {
            let _this = this

            _this.stripe_data.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: _this.stripe_data.card,
                    billing_details: {
                        name: _this.customer.name,
                        address: {
                            line1: _this.customer.address_1,
                            line2: _this.customer.address_2,
                            city: _this.customer.city,
                            postal_code: _this.customer.postcode
                        }
                    }
                }
            }).then(function(result) {
                if (result.error) {
                    _this.stripe_data.error = result.error
                    // Show error to your customer (e.g., insufficient funds)
                    _this.sending = false
                } else {
                    // The payment has been processed!
                    if (result.paymentIntent.status === 'succeeded') {
                        _this.createOrder(result.paymentIntent.status)
                        // Show a success message to your customer
                        // There's a risk of the customer closing the window before callback
                        // execution. Set up a webhook or plugin to listen for the
                        // payment_intent.succeeded event that handles any business critical
                        // post-payment actions.
                    }
                }
            })
        },

        createOrder (paymentIntentStatus) {
            let _this = this


            _this.axios.post('/api/v1/create-order', {
                stripe: {
                    id: _this.stripe_data.payment_intent_id,
                },
                cart: {
                    cart_subtotal:       _this.cartSubTotal,
                    cart_shipping_total: _this.cartShippingTotal,
                    delivery:            `${_this.freeDelivery == true ? 'Free pickup from studio' : 'Home Delivery'}`,
                    cart_total:          _this.cartTotal,
                    products:            _this.cartProducts,
                },
                data: {
                    customer: _this.customer,
                    eventData: _this.eventData,
                },
                order_status: paymentIntentStatus,
            })
            .then((response) => {
                if (response.data.error) {
                    _this.stripe_data.error = response.error
                    _this.sending = false
                } else {
                    // The order has been created
                    if (response.data.status === 'complete') {
                        _this.status = response.data.status
                        _this.sending = false
                    }
                }
            })
        },
    },

}
</script>
<style>
.uk-input-rounded {
    border-radius: 5px;
}

/* Style stripe elements */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
